export default __webpack_public_path__ + "static/sales-rappresentative-7543777c96e26e7b30cbdc5384157b40.jpg";